
const CustomerRoutes = [
  {
    path: '/ecommerce/customers',
    name: 'customers',
    component: () => import(/* webpackChunkName: "customer" */ './views/CustomerView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Customers',
          path: '/ecommerce/customers',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'customers',
        component: () => import(/* webpackChunkName: "customer" */ './components/Customers.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Customers',
              path: '/ecommerce/customers',
            },
          ],
        },
      },
      {
        path: 'new',
        name: 'new-customer',
        component: () => import(/* webpackChunkName: "customer" */ './components/NewCustomer.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'New Customer',
              path: '/ecommerce/customers/new',
            },
          ],
        },
      },
      {
        path: ':id/edit',
        name: 'edit-customer',
        component: () => import(/* webpackChunkName: "customer" */ './components/UpdateCustomer.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Edit Customer',
              path: '/ecommerce/customers/:id/edit',
            },
          ],
        },
      },
      {
        path: ':id/details',
        name: 'customer-details',
        component: () => import(/* webpackChunkName: "customer" */ './components/CustomerDetails.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Customer Details',
              path: '/ecommerce/customers/:id/details',
            },
          ],
        },
      },
    ],
  },
];

export default CustomerRoutes;
